import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation, useQuery, useQueryClient, type QueryKey} from '@github-ui/react-query'

export function collapsedDiffsStatusKey(basePath: string, path: string): QueryKey {
  return [PageData.diffCollapsedStatus, basePath, path]
}

export function useCollapsedDiffStatus(basePath: string, path: string, initialData?: boolean) {
  const queryKey = collapsedDiffsStatusKey(basePath, path)

  return useQuery<boolean>({
    queryKey,
    queryFn: async () => {
      return initialData ? initialData : false
    },
    initialData,
    staleTime: Infinity,
  })
}

export function useUpdateCollapsedDiffStatus() {
  const queryClient = useQueryClient()
  return useMutation({
    onMutate: async (variables: {collapsedStatus: boolean; path: string; basePath: string}) => {
      queryClient.setQueryData(collapsedDiffsStatusKey(variables.basePath, variables.path), () => {
        return variables.collapsedStatus
      })
    },
  })
}
